import { render, staticRenderFns } from "./SidebarMobile.vue?vue&type=template&id=eb44e364"
import script from "./SidebarMobile.vue?vue&type=script&lang=js"
export * from "./SidebarMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavigationAccountSwitcher: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/navigation/AccountSwitcher.vue').default,NavigationNavExpandedSection: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/navigation/NavExpandedSection.vue').default})
